import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';

export const clearProjectsOverviewFilters = createAsyncThunk<void, void, { state: IState }>(
  'uiView/clearProjectsOverviewFilters',
  (_, { dispatch }) => {
    dispatch(persistUserPreferences());
  }
);
